import React from 'react';
import { dayjs } from 'shared/utils/date';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import DragHandle from 'components/DragHandle';
import get from 'get-value';
import { getDisplayValue } from 'shared/utils/dimensionValue';

export const SortableItem = SortableElement(props => <tr {...props} />);
export const SortableBody = SortableContainer(props => <tbody {...props} />);
export const SortHandle = SortableHandle(() => <DragHandle />);

export const propSorter = (prop, compare, hasValue = x => x != null) => (a, b) => {
  const aValue = get(a, prop);
  const bValue = get(b, prop);
  const aValid = !a.other && hasValue(aValue);
  const bValid = !b.other && hasValue(bValue);

  if (aValid && bValid) {
    return compare(aValue, bValue);
  }

  if (aValid) {
    return 1;
  }

  if (bValid) {
    return -1;
  }

  return 0;
};

export const dateSorter = prop => propSorter(prop, (a, b) => dayjs(a).diff(b), x => !!x && dayjs(x).isValid());
export const boolSorter = prop => propSorter(prop, (a, b) => a === b);
export const arraySorter = (prop, itemProp = 'title') => propSorter(prop, (a, b) => a[0][itemProp]?.localeCompare(b[0][itemProp], 'sv', { numeric: true }), x => x?.length > 0);
export const textSorter = prop => propSorter(
  prop,
  (a, b) => getDisplayValue(a).localeCompare(getDisplayValue(b), 'sv', { numeric: true }),
  x => getDisplayValue(x)?.localeCompare,
);
export const numberSorter = prop => propSorter(prop, (a, b) => a - b);

export const getSorter = (type) => {
  switch (type) {
    case 'number':
    case 'percent':
    case 'duration':
      return numberSorter;
    case 'bool':
    case 'boolean':
      return boolSorter;
    case 'date':
    case 'time':
    case 'datetime':
    case 'relativeDate':
      return dateSorter;
    case 'tags':
      return arraySorter;
    default:
      return textSorter;
  }
};
